const COLORS_ARRAY = [


    "#63b598", "#ce7d78", "#ea9e70", "#648177" ,"#0d5ac1", "#07d7f6", "#880977",
    "#f205e6", "#1c0365", "#14a9ad", "#4ca2f9", "#d298e2", "#6119d0", "#b17fc9",
    "#d2737d", "#c0a43c", "#f2510e", "#651be6", "#79806e", "#61da5e", "#cd2f00",
    "#9348af", "#01ac53", "#996635", "#b11573", "#4bb473", "#75d89e", "#d3486d",
    "#2f3f94", "#2f7b99", "#34891f", "#ca4751", "#7e50a8", "#0cd36d", "#5e90e2",
    "#11dec1", "#289812", "#566ca0", "#2f1179", "#fa06ec", "#89d534", "#1ae6db",
    "#935b6d", "#513d98", "#aead3a", "#9e6d71", "#4b5bdc", "#ea24a3", "#04052d",
    "#250662", "#cb5bea", "#228916", "#ac3e1b", "#df514a", "#539397", "#d36647",
    "#679c9d", "#5d2c52", "#48b41b", "#41d158", "#21538e", "#502727", "#55aa99", 
    "#5be4f0", "#57c4d8", "#225b8",  "#be608b", "#96b00c", "#802234", "#c9a941", 
    "#f158bf", "#e145ba", "#ee91e3", "#05d371", "#5426e0", "#4834d0", "#8fb413", 
    "#fb21a3", "#51aed9", "#5bb32d", "#807fb",  "#0971f0", "#6749e8", "#e33e52",  
    "#7fb411", "#0023b8", "#3b8c2a", "#986b53", "#f50422", "#983f7a", "#c79ed2",  
    "#79352c", "#521250", "#89d534", "#0f5997", "#b46238", "#b308d3", "#823c59",
    "#00f87c", "#f50422", "#3f8473", "#15b9ee", "#fc458e", "#406df9", "#7a3d93",
      ];
    
      
      export default COLORS_ARRAY